<template>
  <div class="frame-wrapper">
    <div class="frame-container fill-space inner-frame-wide">
      <slot name="notifications" />
      <div v-if="wrapInContent" class="framer-content">
        <slot />
      </div>
      <slot v-else />
    </div>
    <transition name="sidebar-slide-in">
      <RouterSidebar v-if="sidebarIsVisible" class="router-sidebar">
        <router-view name="sidebar" />
      </RouterSidebar>
    </transition>
  </div>
</template>

<script>
import RouterSidebar from '~components/Navigation/RouterSidebar'

export default {
  name: 'Layout',
  components: { RouterSidebar },
  props: {
    use: {
      type: String,
      default: 'default'
    },
    wrapInContent: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    sidebarIsVisible: false
  }),

  watch: {
    '$route.matched': function(matched) {
      this.checkIfSidebarShouldBeVisible(matched)
    }
  },

  mounted() {
    this.checkIfSidebarShouldBeVisible(this.$route.matched)
  },

  methods: {
    checkIfSidebarShouldBeVisible(matched) {
      const lastMatch = matched[matched.length - 1]
      this.sidebarIsVisible =
        lastMatch &&
        lastMatch.components &&
        typeof lastMatch.components.sidebar === 'object'
    }
  }
}
</script>
